module.exports = __webpack_public_path__ + "img/company.de9b6e27.png";